import { gql } from "@apollo/client";

const VIEW_DASHBOARD = gql`
  mutation viewDashboard {
    viewDashboard {
      data
      status
      error
    }
  }
`;
export default VIEW_DASHBOARD;
